export type NewsListItem = {
  id?: string | number
  slug?: string
  date?: string
}

/** Stable slugs for news articles (shared across locales). */
export const NEWS_ID_TO_SLUG: Record<string, string> = {
  '1': 'pacific-link-ceo-meets-nauru-program-office-auckland',
  '2': 'nauru-ecrcp-digital-submission',
  '3': 'vanuatu-citizenship-gazette-amendments-2026',
  '4': 'vanuatu-government-service-visit-australia-may-2026',
  '5': 'nauru-citizenship-stateless-resident-june-2026',
  '6': 'nauru-citizenship-by-investment-application-process',
  '7': 'canada-working-holiday-visa-australians-iec-2026',
  '8': 'canadian-citizenship-by-descent-australians-guide',
  '9': 'naoero-official-name-change-july-2026',
  '10': 'nauru-vs-sao-tome-citizenship-comparison',
  '11': 'why-vanuatu-passport-still-king-of-cbi',
  '12': 'naoero-australia-awards-scholarships-2027',
  '13': 'mainland-china-business-model-adjustment-2026',
  '14': 'sao-tome-cbi-first-annual-report-2026',
  '15': 'argentina-cbi-pricing-and-launch-timeframe-2026',
  '16': 'sierra-leone-citizenship-simple-documents-remote-application',
  '17': 'saint-vincent-redesigned-citizenship-programme-q1-2027',
  '18': 'abc-radio-australia-nauru-citizenship-interview',
  '19': 'malta-citizenship-by-merit-framework',
  '20': 'sierra-leone-go-for-growth-rebrand',
}

export function resolveNewsSlug(idOrSlug: string): string {
  return NEWS_ID_TO_SLUG[idOrSlug] ?? idOrSlug
}

/** Newest first; items without a parseable date sink to the bottom. */
export function sortNewsListByDateDesc<T extends NewsListItem>(items: T[]): T[] {
  return [...items].sort((a, b) => {
    const ta = a.date ? Date.parse(a.date) : Number.NaN
    const tb = b.date ? Date.parse(b.date) : Number.NaN
    const na = Number.isFinite(ta) ? ta : Number.NEGATIVE_INFINITY
    const nb = Number.isFinite(tb) ? tb : Number.NEGATIVE_INFINITY
    return nb - na
  })
}
